import React from 'react'
import useQuery from 'apollo-hooks/lib/useApolloQuery'
import gql from 'graphql-tag'
import Select from 'orionsoft-parts/lib/components/fields/Select'

export default function ZoneOfCountry(props) {
  const {countryCode, countryCodes} = props.passProps
  const {zones} = useQuery({
    query: gql`
      query getZonesOfCountry($countryCode: String, $countryCodes: [String]) {
        zones(countryCode: $countryCode, countryCodes: $countryCodes) {
          _id
          items {
            value: _id
            label: name
          }
        }
      }
    `,
    variables: {countryCode, countryCodes}
  })

  return <Select placeholder="Selecciona una zona" {...props} options={zones.items} />
}
